import { withChartLayout } from 'components/common';
import MusculoskeletalAssessment from 'components/features/chart/system-assessment/musculoskeletal-assessment/MusculoskeletalAssessment';

const MusculoskeletalAssessmentPage = withChartLayout('Musculoskeletal Assessment')(MusculoskeletalAssessment);
export default MusculoskeletalAssessmentPage;
